import { jsx as _jsx } from "jsx-dom/jsx-runtime";
/** @jsxImportSource jsx-dom */
export var Loader = function () {
    return (_jsx("img", { src: "/marketplace/images/loader.svg", class: "loader", style: "width:50px; height:auto;display:block;margin:20px auto;" }));
};
